import React from 'react';
import { bool, func, string } from 'prop-types';

import CSS from './button.scss';


const Button = props => {
  const { label, onClick, className } = props;
  const styling = `${className ? className : ''}`;

  return (
    <div className={ styling }>
       <button className={ CSS['btn'] }
        onClick={ onClick } >{ label }
      </button>
    </div>
  );
};

Button.propTypes = {
  label: string.isRequired,
  onClick: func,
  primary: bool
};


export default Button;
